(function() {
  function removeBuyItNowButtons() {
    var optionsDiv = document.querySelector('.bold_options_loaded');

    if (optionsDiv && optionsDiv.children.length !== 0) {
      var buyItNow = document.querySelectorAll('.shopify-payment-button');

      console.log('Removing Buy It Now buttons:', buyItNow);

      Array.prototype.forEach.call(buyItNow, function(button) {
        if (button && button.parentNode) {
          button.parentNode.removeChild(button);
        }
      });
    }
  }

  function initBoldListener() {
    if (
      typeof BOLD !== 'undefined' &&
      BOLD.common &&
      BOLD.common.eventEmitter &&
      typeof BOLD.common.eventEmitter.on === 'function'
    ) {
      console.log('BOLD detected, attaching event listener');

      BOLD.common.eventEmitter.on('BOLD_OPTIONS_option_products_loaded', function() {
        console.log('Event emitted: BOLD_OPTIONS_option_products_loaded');

        setTimeout(removeBuyItNowButtons, 500);
      });

      return true;
    }
    return false;
  }

  function waitForBold() {
    if (!initBoldListener()) {
      setTimeout(waitForBold, 200);
    }
  }

  function initMutationObserver() {
    var target = document.body;

    if (!target || !window.MutationObserver) return;

    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes && mutation.addedNodes.length > 0) {
          setTimeout(removeBuyItNowButtons, 500);
        }
      });
    });

    observer.observe(target, {
      childList: true,
      subtree: true
    });

    console.log('MutationObserver fallback initialized');
  }

  document.addEventListener('DOMContentLoaded', function() {
    waitForBold();           // Try to hook into BOLD event
    initMutationObserver();  // Fallback if event fails
  });
})();
